/* eslint-disable import/prefer-default-export */
/**
 * @deprecated Use getFlagIcon from services/countryService in React code.
 */
export const getCountryFlagEmoji = (countryCode = '') => {
  if (typeof countryCode !== 'string') return '';

  const codePoints = countryCode
    .toUpperCase()
    .split('')
    .map((char) => 127397 + char.charCodeAt());
  return String.fromCodePoint(...codePoints);
};

export const countryFlagHtml = (countryCode = '') => {
  if (typeof countryCode !== 'string') return '';

  const normalizedCode = countryCode.trim().toLowerCase();
  if (!/^[a-z]{2}$/.test(normalizedCode)) return '';

  return `<span class="flag-icon flag-icon-${normalizedCode} flag-icon-squared"></span>`;
};
